import React from 'react';
import cn from 'classnames';
import { useStatusBadgeIcon } from './hooks/useStatusBadgeIcon.js';

var defaultColors = {"positive-checkmark":"status-badge__positive-checkmark_3hnxu","negative-cross":"status-badge__negative-cross_3hnxu","negative-alert":"status-badge__negative-alert_3hnxu","negative-block":"status-badge__negative-block_3hnxu","attention-alert":"status-badge__attention-alert_3hnxu","neutral-information":"status-badge__neutral-information_3hnxu","neutral-operation":"status-badge__neutral-operation_3hnxu","neutral-cross":"status-badge__neutral-cross_3hnxu"};
require('./default.css')

var styles = {"component":"status-badge__component_1n4ae","size-16":"status-badge__size-16_1n4ae","size-20":"status-badge__size-20_1n4ae","size-24":"status-badge__size-24_1n4ae","size-32":"status-badge__size-32_1n4ae","size-40":"status-badge__size-40_1n4ae"};
require('./index.css')

var invertedColors = {"positive-checkmark":"status-badge__positive-checkmark_nqzo9","negative-cross":"status-badge__negative-cross_nqzo9","negative-alert":"status-badge__negative-alert_nqzo9","negative-block":"status-badge__negative-block_nqzo9","attention-alert":"status-badge__attention-alert_nqzo9","neutral-information":"status-badge__neutral-information_nqzo9","neutral-operation":"status-badge__neutral-operation_nqzo9","neutral-cross":"status-badge__neutral-cross_nqzo9"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var StatusBadge = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, _b = _a.size, size = _b === void 0 ? 24 : _b, view = _a.view, _c = _a.colors, colors = _c === void 0 ? 'default' : _c, customIcons = _a.customIcons;
    var Icon = useStatusBadgeIcon(view, size, customIcons).Icon;
    return (React.createElement("div", { className: cn(styles.component, className, styles["size-".concat(size)], colorStyles[colors].component, colorStyles[colors][view]), "data-test-id": dataTestId },
        React.createElement(Icon, null)));
};

export { StatusBadge };
